<template>
  <div>
    <!-- SECCIONES -->
      <vs-tabs v-if="isMounted" :position="isSmallerScreen ? 'top' : 'left'" v-model="activeTab" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
        <vs-tab :label="group.title" icon-pack="feather" :icon="group.icon" v-for="(group, i) in getSectionGroups()" :key="i">
          <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
            <vx-card no-shadow >
              <vx-card v-for="section in getSectionsForGroup(group)" :key="section.data.id" :title="section.data.public_name" class="mb-5">
                <p class="mb-4" v-if="section.data.public_description != null">{{section.data.public_description}}</p>

                <div class="vx-row">
                  <template v-for="f in section.data.fields">

                    <!-- Campos automaticos -->
                    <form-field
                      :ref="'section' + section.data.id"
                      v-if="isAutoFormField(f)"
                      :key="f.id"
                      :f="f"
                      :keepDisabled="isDisabled"
                      :dataContainer="getContainerForField(section, f)"
                      :collectionsRoot="collections"
                      :onChangeReceptor="onFieldChange"
                      :hasBackofficeAccess="hasBackofficeAccess"
                      :inputClassLarge="true"
                      :evaluator="evaluateCondition" />

                  </template>
                </div>

                <div v-if="section.data.id == 95">
                  <vs-divider></vs-divider>
                  <resources-destination-control
                    :projectId="currentProjectId"
                    ></resources-destination-control>
                  <vs-divider></vs-divider>
                  <loan-guarantees-control
                    :projectId="currentProjectId"
                    ></loan-guarantees-control>
                  <vs-divider></vs-divider>
                  <extra-project-documentation
                    :projectId="currentProjectId"
                    ></extra-project-documentation>
                  <vs-divider></vs-divider>
                </div>

                <!-- Save Button -->
                <div class="vx-row" v-if="!isDisabled && !section.data.skipBtn">
                  <div class="vx-col w-full">
                    <div class="mb-4 mt-4 w-full" v-if="section.data.id == 95">
                      <vs-table stripe :data="locations" noDataText="No se han generado registros">
                      <template slot="header"><h3>Lista de inmuebles</h3></template>
                        <template slot="thead">
                          <vs-th class="bold">ID</vs-th>
                          <vs-th class="bold">DIRECCIÓN</vs-th>
                          <vs-th class="bold">TIPO DE INMUEBLE</vs-th>
                          <vs-th class="bold">NOMBRE DEL NEGOCIO</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                            <vs-td :data="data[indextr].id">
                              {{ (data[indextr].id) }}
                            </vs-td>

                            <vs-td :data="data[indextr].location.address_id">
                              {{ uppercase(data[indextr].location.address.full_address) }}
                            </vs-td>

                            <vs-td :data="data[indextr].location.address_id">
                              {{ (data[indextr].location.type ? translateType(data[indextr].location.type) : "--") }}
                            </vs-td>

                            <vs-td :data="data[indextr].location.address_id">
                              {{ (data[indextr].location.name ? data[indextr].location.name : "--") }}
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                    <div class="flex flex-wrap items-center justify-end">
                      <vs-button class="ml-auto mt-2" @click="saveGroupChanges(section)">Guardar cambios</vs-button>
                    </div>
                  </div>
                </div>
                <template v-if="section.data.id == 95 && base.finance.loan_type == 4">
                  <vs-divider></vs-divider>
                  <h6 class="mb-3">Documentos</h6>
                  <div class="vx-row">
                    <document-upload-lite
                      :accepts="['png','jpg','jpeg']"
                      upload-type="public_cover_image"
                      name="Portada de proyecto"
                      :check-url="checkUrl"
                      :view-url="viewUrl"
                      :download-url="downloadUrl"
                      :upload-url="uploadUrl"
                      width="1/4"
                      />
                  </div>
                </template>

                <template v-if="section.data.id == 95">
                  <vs-divider></vs-divider>
                  <h6 class="mb-3">Documentos</h6>
                  <div class="vx-row">
                    <document-upload-lite
                      :accepts="['png','jpg','jpeg']"
                      upload-type="promo-cover"
                      name="Imagen de la promoción"
                      :check-url="checkPromoUrl"
                      :view-url="viewPromoUrl"
                      :download-url="downloadPromoUrl"
                      :upload-url="uploadPromoUrl"
                      width="1/4"
                      />
                  </div>

                </template>
                
                <template v-if="section.data.id == 152">
                  <vs-divider></vs-divider>
                  <h6 class="mb-3">Documentos</h6>
                  <div class="vx-row">
                    <document-upload-lite
                      :accepts="['png','jpg','jpeg']"
                      upload-type="logo"
                      name="Logo"
                      :check-url="checkUrlLogo"
                      :view-url="viewUrlLogo"
                      :download-url="downloadUrlLogo"
                      :upload-url="uploadUrlLogo"
                      width="1/4"
                      />
                      <div class="vx-col sm:w-full">
                        <business-profile-images-control 
                          :userId="base.client.user_id"
                          :projectId="currentProjectId"
                          :businessProfileId="base.client.user.business_profile_id"
                        />
                      </div>
                  </div>

                </template>

                 <template v-if="section.data.documentFields.length > 0">
                  <vs-divider></vs-divider>
                  <h6 class="mb-3">Documentos</h6>
                  <div class="vx-row">
                    <document-upload
                    v-for="df in section.data.documentFields"
                    :key="df.id"
                    :target_id="df.target_id"
                    :f="df.formField"
                    :doc="df.documentSet"
                    :inputClassLarge="false"
                    :disabled="isDisabled"
                    :from_project_id="id"
                    :evaluator="evaluateCondition"
                    />
                  </div>
                </template>

              </vx-card>

            </vx-card>
          </div>
        </vs-tab>

      </vs-tabs>

  <load-error v-if="failed" />

  </div>
</template>

<script>
import inputHelper from '@components/mixins/inputHelper';
import dateHelper from '@components/mixins/dateHelper';
import formHelper from '@components/mixins/formHelper';
import formatHelper from '@components/mixins/formatHelper';
import FormField from '@components/forms/FormField.vue';
import ResourcesDestinationControl from './resourcesDestination/ResourcesDestinationControl.vue';
import LoanGuaranteesControl from './loanGuarantees/LoanGuaranteesControl.vue';
import DocumentUploadLite from "@components/misc/DocumentUploadLite";
import BusinessProfileImagesControl from './BusinessProfileImagesControl.vue';
import ExtraProjectDocumentation from './extraProjectDocumentation/ExtraProjectDocumentation.vue';

const tabsDefs = [
  { slug: "publication", title: "Datos para publicación", icon: "icon-user", sections:[95,96] },
];

const tabsPMDefs = [
  { slug: "publication", title: "Datos para publicación", icon: "icon-user", sections:[95,96,152] },
];

const sectionsToContainers = [
  { id: 95, containers: [
    {db:'projects', path:'base'},
    {db:'project_finances', path:'finance'}
  ]},
  { id: 96, containers: [
    {db:'suppliers', path:'supplier'},
    {db:'none', path:'base'},
    {db:'computed', path:'calculations'},
  ]},
  { id: 152, containers: [
    {db:'business_profiles', path:'client.user.business'}
  ]}
];

const requiredObjects = [
  'finance',
  'supplier.user',
  'splits',
  'client.user.business'
];

const appendObjects = [
  'subcategory'
];

const arrayPaths = [];

export default {
  mixins: [formHelper, inputHelper, dateHelper, formatHelper],
  props: ['id', "isDisabled", "person_type"],
  data(){
    return {
      errorCode: 0,
      onError: false,

      pmClientType: 0,
      pfClientType: 1,

      form_id: 45,

      isMaster: null,

      loading: false,
      isMounted: false,
      isRefreshing: false,
      errorMssg: '',
      successMssg: '',
      failed: false,

      flow: {},
      allSections: [],
      sectionGroups: [],

      documentsStates: [],

      tabs: tabsDefs,

      isMoral: false,
      isPfae: false,
      activeTab: 0,

      collections: {
        terms: [],
        cover_images: [],
        project_types: [],
        project_type_subcategories: [],
        project_categories: [],
      },

      // objeto principal
      base: {},

      // auxiliares para evaluacion de condiciones
      mexicoCountryId: 700,

      // objetos para actualizaciones
      basePayload: {},
      validatedFields: [],
      currentSupplierUserId: null,

      calculations: {
        monto_fondeado: 0,
        avance_fondeo: 0,
        num_inversionistas: 0,
        participacion_rg: 0,
        garantia: null,
        ahorro_mensual: null,
        cobertura: null,
        inversion: null,
        beneficio: null,
      },

      locations: []
    }
  },
  components: {
    FormField,
    ResourcesDestinationControl,
    DocumentUploadLite,
    LoanGuaranteesControl,
    BusinessProfileImagesControl,
    ExtraProjectDocumentation
  },
  computed: {
    checkUrl() {
      if (this.id) {
        return `project/${this.id}/cover/info`;
      }
      return null;
    },
    viewUrl() {
      if (this.id) {
        return `project/${this.id}/cover/view`;
      }
      return null;
    },
    downloadUrl() {
      if (this.id) {
        return `project/${this.id}/cover/download`;
      }
      return null;
    },
    checkPromoUrl() {
      if (this.id) {
        return `project/${this.id}/promo/info`;
      }
      return null;
    },
    viewPromoUrl() {
      if (this.id) {
        return `project/${this.id}/promo/view`;
      }
      return null;
    },
    downloadPromoUrl() {
      if (this.id) {
        return `project/${this.id}/promo/download`;
      }
      return null;
    },
    uploadPromoUrl() {
      if (this.id) {
        return `project/${this.id}/promo/upload`;
      }
      return null;
    },    
    checkUrlLogo() {
      if (this.id) {
        return `business-profile/${this.id}/logo/info`;
      }
      return null;
    },
    viewUrlLogo() {
      if (this.id) {
        return `business-profile/${this.id}/logo/view`;
      }
      return null;
    },
    downloadUrlLogo() {
      if (this.id) {
        return `business-profile/${this.id}/logo/download`;
      }
      return null;
    },
    uploadUrlLogo() {
      if (this.id) {
        return `business-profile/${this.id}/logo/upload`;
      }
      return null;
    },
    hasBackofficeAccess(){
      return this.$acl.check('isBackoffice');
    },
    isSmallerScreen () {
      return this.$store.state.windowWidth < 2000
    },
    currentProjectId(){
      return this.id;
    },
    currentClientUserId(){
      return this.base.client_id;
    }
  },
  async mounted() {
    this.loading = true;
    this.isMounted = false;
    await this.getCollections();
    await this.getProjectData();
    this.setSupplierUserId();
    this.setClientPersonTypeInfo();
    await this.setCustomIntegrations();
    await this.getFormInfo();
    this.setSectionGroups();
    await this.getSpecialCalculations();
    this.getLocationLists();
    this.isMounted = true;
    this.loading = false;
  },
  watch: {
    loading : function(newVal, oldVal){
      if(newVal === true){
         this.$vs.loading();
      }
      else {
        this.$vs.loading.close();
      }
    },
  },
  methods: {
    async getLocationLists() {
      try {
        const res = await axios.get(`/api/get/fg_locations/type-name/${this.id}`);
        this.locations = res.data;
      } catch (error) {

      }
    },
    translateType(status) {
      if(status == "home"){
        return "Casa particular";
      } else if(status == "business") {
        return "Negocio";
      } else {
        return "Casa con negocio";
      }
    },
    setSupplierUserId(){
      this.currentSupplierUserId = this.base.supplier != null ? this.base.supplier.user_id : null;
    },
    getSectionGroups(){
      return this.sectionGroups;
    },
    getSectionsForGroup(group){
      return group.sections.filter(f=> f.data.fields.length > 0);
    },
    async reloadFormInfo(){
      this.isRefreshing = true;
      await this.getProjectData();
      await this.setCustomIntegrations();
      this.reloadSectionGroups();
      this.set_social_network_object();
      this.isRefreshing = false;
    },
    async saveGroupChanges(section){
      let result = await this.runValidations(section);
      if(!result){
       this.missingFieldsNotif();
      }
      else {
        this.loading = true;

        //guardar solo la informacion que se ha modificado
        this.basePayload = this.collectFormData(section);

        // conversion de finance.deposit_percentage
        let finance = this.basePayload.finance;
        if(finance && finance.annual_interest_percentage != null){
        finance.annual_interest_percentage_unit = this.decimalsFormat(finance.annual_interest_percentage * 100, 2);
      }

        if(this.objectIsEmpty(this.basePayload)){
          //this.notFieldsToUpdate();
          this.saveSuccessNotif();
          this.loading = false;
          return;
        }

        this.basePayload.id = this.base.id;

        try {
          // ejecutar guardado
          const res = await axios.put(`/api/v2/projects/${this.id}/deepUpdate`, this.basePayload);

          if(res.satus == 423){
            this.failedOperationNotif(null, "CURP o RFC duplicados.");
          }
          // solicitar la informacion actualizada del modelo
          await this.reloadFormInfo();

          this.saveSuccessNotif();
        }
        catch (error) {
          this.failedOperationNotif(null, null);
        }

        this.loading = false;
      }
    },
    async runValidations(section){
       // validar componentes tipo FormField
       let gslug = "section" + section.data.id;
      let res1 = await this.validateFormFields(gslug);
      if(!res1){
        return false;
      }

      // validar inputs instanciados en la vista
      let res2 = await this.$validator.validateAll();
      if(!res2){
        return false;
      }

      // inspeccionar los campos para ejecutar validaciones especiales
      let spValidation = await this.checkFormFieldsSpecialValidations(gslug);
      if(!spValidation){
        return false;
      }

      // inspeccionar los campos agregados directo en el componente para ejecutar validaciones especiales

      let sp_failed = false;

        section.data.fields.filter(f => f.special_definition === 1).forEach(f => {
          // considerar los campos habilitados (visibles), con validaciones especiales
          if(this.fields[f.fname] && f.special_validation !== null && f.special_validation.method !== null) {
            let res = this[f.special_validation.method]();

            if(!res){
              this.errors.add({
                field: f.fname,
                msg: f.special_validation.error
              });
              this.missingFieldsNotif(f.field_name, f.special_validation.error, 10000);
              sp_failed = true;
            }
          }
        });

      if(sp_failed){
        return false;
      }

      // retornar true si todas las validaciones fueron positivas
      return true;
    },
    collectFormData(section){
      let payload = {};
        section.containers.forEach(cc => {
          let fields = this.validatedFields.filter(vf => vf.db === cc.db);
          if(fields.length < 1){
            return;
          }

          if(cc.path === "base"){
            fields.forEach(f => {
              payload[f.fname] = cc.container[f.fname];
            });
          }
          else {
            let obj = null;
            if(arrayPaths.includes(cc.path)){
              // se integran todos los objetos de la coleccion
              obj = this.nestedFieldValue(this.base, cc.path);
            }
            else {
              obj = {id: cc.container.id};
              fields.forEach(f => {
                obj[f.fname] = cc.container[f.fname];
              });
            }
            // ajuste para objetos tipo array
            this.setNestedObjectWithIds(payload, this.base, cc.path, obj);
          }
        });
      return payload;
    },
    async validateFormFields(refGroup){
      let allValid = true;
      this.validatedFields = [];
      let grefs = this.$refs[refGroup];
      for(let p in grefs){
        let r = await this.$refs[refGroup][p].checkForValidDirty();
        if(r.valid == false){
          allValid = false;
        }
        else if(r.dirty == true) {
          this.validatedFields.push(r);
        }
      }
      return allValid;
    },
    async checkFormFieldsSpecialValidations(refGroup){
      let spvalid = true;
      let grefs = this.$refs[refGroup];
      let f;
      for(let p in grefs){
        f = grefs[p];
        let sp = f.specialValidation();
        if(sp != null){
          let res = await this[sp.method]();
          let n = f.rawFieldName;
          if(!res){
            spvalid = false;
            f.setError(sp.error);
            this.errorNotif(n, sp.error, 10000);
          }
        }
      }
      return spvalid;
    },
    async onFieldChange(method){
      if(method != null && method in this){
        await this[method]();
      }
    },
    /* evaluator */
    evaluateCondition(condition){
      return this.evaluateConditionBase(this, condition);
    },

    /* obtener ids para los casos correspondientes */
   docTargetEvaluator(cls, cls_2){
      if(cls === 'user'){
        if(cls_2 === 'supplier'){
          return this.currentSupplierUserId;
        }
        else if(cls_2 === 'applicant'){
          return this.base.client.user.id;
        }
      }
      else if(cls === 'project'){
        return this.currentProjectId;
      }
      this.warn(`DOC TARGET NOT DEFINED FOR classifications: ${cls},${cls_2}`);
      return null;
    },

    setClientPersonTypeInfo(){
      this.isMoral = this.person_type === this.pmClientType;
      this.isPfae = this.person_type === this.pfClientType;

      this.tabs = this.isMoral ? tabsPMDefs : tabsDefs;
    },
    async setCustomIntegrations(){
      let finance = this.base.finance;
      if(finance && finance.annual_interest_percentage != null){
        finance.annual_interest_percentage_unit = this.decimalsFormat(finance.annual_interest_percentage * 100, 2);
      }
    },
    setSectionGroups(){
      this.tabs.forEach(t => {
        let group = { title: t.title, icon: t.icon, slug: t.slug }; //, vModel: this.getModelForGroup(t.slug) };
        let sections = [];

        t.sections.forEach(ss => {
          let s = this.allSections.find(f => f.id === ss);
          if(s != null){
            let sb = { data: s, containers: this.getContainersForSection(s.id) };
            sections.push(sb);
          }
          else {
            this.warn("Section " + ss + " not found");
          }
        })
        group.sections = sections;
        this.sectionGroups.push(group);
      });
    },
    reloadSectionGroups(){
      this.sectionGroups.forEach(group => {
        group.sections.forEach(s => {
          s.containers = this.getContainersForSection(s.data.id);
        })
      });
    },
    getContainerForField(section, f){
      if(f.db_table === 'computed'){
        return this.calculations;
      }

      let c = section.containers.find(sc => sc.db === f.db_table);
      if(!c){
        this.warn(`Container not found for db [${f.fname}]: ${f.db_table}`);
        return null;
      }
      else {
        return c.container;
      }
    },
    getContainersForSection(section_id){
      let c = sectionsToContainers.find(f => f.id === section_id);
      if(!c){
        this.warn("Missing containers definition for section " + section_id);
        return null;
      }
      else {
        let sectionContainers = [];
        c.containers.forEach(cc => {
          let con = this.setContainerFromDef(cc);
          sectionContainers.push({db: cc.db, path: cc.path, container: con});
        })
        return sectionContainers;
      }
    },
    setContainerFromDef(c){
      let container = this.nestedFieldValue(this.base, c.path);
      if(Array.isArray(container)){
        let ac = null;
        if(c.arrayDefs){
          if(c.arrayDefs.getFirst === true){
            ac = container[0];
          }
          else if(c.arrayDefs.eval){
            // llamado en funciones de secciones
            ac = this[c.arrayDefs.eval](container);
          }
        }
        if(!ac){
          if(c.arrayDefs.onNull){
            if(c.arrayDefs.onNull in this) {
              ac = this[c.arrayDefs.onNull]();
            }
            else {
              this.warn("Missing method definition for container " + c.path + ", " + c.db + ": " + c.arrayDefs.onNull );
            }
          }
          else { ac = {} }
          container.push(ac);
        }
        return ac;
      }
      else {
        if(!container && c.objDefs && c.objDefs.onNull){
          if(c.objDefs.onNull in this) {
              container = this[c.objDefs.onNull]();
            }
            else {
              this.warn("Missing method definition for container " + c.path + ", " + c.db + ": " + c.objDefs.onNull );
            }
        }
        if(!container){
          container = {};
        }
        return container;
      }
    },
    async getProjectData(){
      try{
        // ?filter[status]=3 // ejemplo de filtro
        let appends = "&append[]=" + appendObjects.join("&append[]=");
        let params = "with[]=" + requiredObjects.join("&with[]=");
        let response = await axios.get(`/api/v2/projects/${this.id}?${params}${appends}`);
        this.base = response.data;
        this.isMaster = this.base.splits.length > 0;
      }
      catch(e){
        this.warn(e);
        this.failed = true;
      }
    },
    async getFormInfo(){
      try{
        let id = this.form_id;
        let response = await axios.get("/api/v1/forms/getFormFields/" + id);
        let url = this.ApiDomain + `/storagev3/documents/form/${id}`;
        let response2 = await axios.get(url);
        this.documentsStates = response2.data;

        this.flow = response.data.flow;
        this.allSections = response.data.sections;

        this.allSections.forEach(s => {
          if(this.tabs.filter(tt => tt.sections.includes(s.id)).length < 1){
            return;
          }

          s.documentFields = [];
          let co = 0;
          s.fields.forEach(f => {
            this.formFieldSetter(f, this);
            if (this.isAutoFieldToSave(f)) {co += 1}
            // check for documents
            if(f.doc_id != null){
              let ff = {formField: f, documentSet: null, target_id: null };
              let ss = this.documentsStates.find(sid => sid.id === s.id);
              if(ss && ss.documents){
                let dset = ss.documents.find(d => d.id === f.doc_id);
                if(dset){
                  ff.target_id = this.docTargetEvaluator(dset.clasification, dset.clasification_2);
                  ff.documentSet = dset;
                }
              }
              s.documentFields.push(ff);
            }
          });

          if(co === 0){
            s.skipBtn = true;
          }
        });
      }
      catch(e){
        this.warn(e);
        this.failed = true;
      }
    },
    async getCollections(){
      try {
        let collectionsObjects = ['projectValidTerms','projectTypeSubcategories', 'projectTypes','getProjectCategoriesList'];

        let params = "with[]=" + collectionsObjects.join("&with[]=");
        let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
        this.collections.terms = res.data.projectValidTerms;
        this.collections.cover_images = res.data.coverImagesList;
        this.collections.project_types = res.data.projectTypes;
        this.collections.project_type_subcategories = res.data.projectTypeSubcategories;
        this.collections.project_categories = res.data.getProjectCategoriesList;
      }
      catch (e) {
        this.warn(e);
        this.failed = true;
      }
    },
    processError(code){
      this.onError = true;
      this.errorCode = code;
    },

    async getSpecialCalculations(){
      try {
        const response = await axios.get(`/api/projects/single/${this.id}`);
        const project = response.data.project;
        const finance = response.data.finance;

        this.calculations.monto_fondeado = project.invested;
        this.calculations.avance_fondeo = project.invested/(finance.financed_amount);
        this.calculations.num_inversionistas = project.inversionistas;
        this.calculations.participacion_rg = project.rg_participation;
        this.calculations.garantia = `${(finance.total_cost/finance.financed_amount).toFixed(2)} a 1`;
        this.calculations.ahorro_mensual = project.saving_per_year/12;
        this.calculations.cobertura = project.saving_per_year/(finance.monthly_payment *12);
        this.calculations.inversion = `$1 MXN = ${project.investment_environmental_impact.toFixed(2)} kgCO•2`;
        this.calculations.beneficio = `${(project.environmental_impact/1000).toFixed(2)} TonCO•2`;
        this.calculations.environmental_impact = `${finance.environmental_impact !== null ? finance.environmental_impact : 0} kgCO•2`;
        this.calculations.economic_impact = `$${this.format_price(finance.economic_impact)}`;
      } catch (error) {
        this.warn(error);
        this.failedOperationNotif("Error inesperado", `Contacte a soporte técnico. Error: ${error.message}`);
      }

    },

    set_fiscal_business_type() {
      if(this.base.client.user.business.fiscal_business_type !== null){
        const businessType = {
          "sacv" : 1
        , "sapi" : 2
        , "scoop" : 3
        , "scivil" : 4
        , "ac" : 5
        , "abp" : 6
        , "srlcv": 7
        };
        this.base.client.user.business.fiscal_business_type = (businessType[this.base.client.user.business.fiscal_business_type]||null);
      }

      return null;
    },
    set_social_network_object() {
      if(this.base.client.user.business.social_networks != null) {
        let aux = JSON.parse(this.base.client.user.business.social_networks);
        this.base.client.user.business.social_networks = aux.join();
      }
    }
  },

}
</script>
